import React from 'react'
import Helmet from 'react-helmet'

import config from '../config'

import '../css/index.css'
import {
  Navigation,
  Sayonara
} from '../components'

export default class Index extends React.Component {
  render() {
    return (
      <div>
        <Helmet
          title="Bowtie"
          meta={[
            { name: "description", content: "We make apps for iOS and Android that people just love to use. Working tight with humongous companies and tiny startups. We fall for brave visions, superb user experiences and digital greatness." },
            { property: "og:image", content: `${config.baseUrl}${require('../images/facebok-open-graph@2x.png')}` },
          ]}
        />
        <Navigation />
        <Sayonara />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js